<template>
  <section class="card">
    <div class="PlanInformation">
      <header class="CardHeader">
        <div class="Recomended" v-if="ShowRecomendar">
          <span>Recomendado</span>
          <!-- <main class="Tooltip">
            <section>
              <span> {{ recomendar }}</span>
            </section>
          </main> -->
        </div>
        <img :src="Plano.operadoraLogo" alt="logo" />

        <div class="TopCardInfo">
          <h5 class="PlanName">{{ Plano.operadoraNome }}</h5>
        </div>
        <div class="Line" :style="{ backgroundColor: planColor.startsWith('#') ? planColor : '#' + planColor }"></div>

        <span class="Modalidade">{{ Plano.modalidade }}</span>

        <div class="PlanSubNameBox">
          <p>{{ Plano.nome }}</p>
        </div>

      </header>

      <div class="Info">

        <div class="HeaderInfo" ref="HeaderSection">
          <h6 class="PlanSubName" v-html="Plano.nome"></h6>

          <i v-if="isSimulacaoRoute" class="fa-solid fa-sort-down fa-lg"
            style="cursor: pointer; margin-right: .3rem;  color: #343a40; display: flex; margin-top: -.3rem;"
            @click="showButtons = !showButtons"></i>
        </div>

        <div class="ButtonsContainer" v-if="showButtons">

          <div class="ButtonsBox">
            <div @click="chamarEditaPlano" ref="btnShowOperadora" href="#">
              <b-icon icon="pencil-fill" variant="warning"></b-icon>
              Alterar Plano
            </div>
            <div @click="chamarRemovePlano" href="#">
              <b-icon icon="trash-fill" variant="danger"></b-icon>
              Remover Plano
            </div>
          </div>
        </div>

      </div>

      <div class="MiddleInfo">
        <span>Acomodação: <b>{{ Plano.acomodacao }} </b></span>
        <span>Abrangência: <b>{{ Plano.atuacao }}</b></span>
        <span>Coparticipação:
          <b :style="{ color: Plano.coparticipacao === 'nao' ? '#f56c6c' : '#41b883' }">{{ Plano.coparticipacao === 'nao' ? 'Não' : 'Sim' }}</b>
        </span>
        <span>Reembolso:
          <b :style="{ color: Plano.reembolso == 0 ? '#f56c6c' : '#41b883' }" class="MiddleValue">{{Plano.reembolso == 0 ? 'Não' : 'Sim' }}</b>
        </span>
        <span>Aceita MEI:
          <b :style="{ color: Plano.mei == 0 ? '#f56c6c' : '#41b883' }" class="MiddleValue">{{Plano.mei == 0 ? 'Não' : 'Sim' }}</b>
        </span>
      </div>

      <div class="table-container">
        <section style="width: 250px; margin: .5rem auto;">
          <table style="width: 250px; margin: 0 auto;">
            <thead>
              <tr>
                <th class="column-margin" style="font-weight: 600; font-size: 13px">Idade</th>
                <th class="column-margin" style="font-weight: 600; font-size: 13px">Vidas</th>
                <th class="column-margin" style="font-weight: 600; font-size: 13px">Preço Unit.</th>
                <th class="column-margin"> </th>
                <th class="column-margin" style="font-weight: 600; font-size: 13px">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(valor, idade) in Titulares" :key="idade">
                <td class="column-margin" style="font-weight: 600; font-size: 80%">{{ idade }}</td>
                <td class="column-margin" style="font-weight: 600; font-size: 80%">{{ extractLives(valor) }}x</td>
                <td class="column-margin" style="font-weight: 600; font-size: 80%">{{ extractPrice(valor) }}</td>
                <td style="width: 15px; text-align: center; font-weight: 100;">=</td>
                <td class="column-margin" style="font-weight: 600; font-size: 80%">{{ calculateTotal(extractPrice(valor), extractLives(valor)) }}</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>

      <div class="PlanValue">
        <div class="Price">
          <p class="MoneySign">R$</p>
          <p class="Value"> {{ parseFloat(Plano.taxas.iof == true ? Plano.calculo.total_iof : Plano.calculo.total).toLocaleString('pt-br',
            { minimumFractionDigits: 2 }) }}*</p>
          /mês
          <main class="SubTotalBox">
            <section>
              <span> {{ calculoDescricao }}</span>
            </section>
          </main>
        </div>
      </div>

      <div class="BottomButtons">

        <div class="Hospitals" :style="{ bottom: isSimulacaoRoute ? '45px' : '80px'}">{{ TotalHospitals }}</div>
        <button @click="chamarMaisInformacoes('rede')">
          <font-awesome-icon :icon="['fas', 'hospital']" style="width: 11px; height: 11px;" />
          Hospitais
        </button>

        <div class="Laboratories" :style="{ bottom: isSimulacaoRoute ? '45px' : '80px'}">{{ TotalLaboratories }}</div>
        <button @click="chamarMaisInformacoes('rede')">
          <font-awesome-icon :icon="['fas', 'flask']" style="width: 10px; height: 10px;" />
          Laboratórios
        </button>

        <button @click="chamarMaisInformacoes('valores')">
          <font-awesome-icon :icon="['fas', 'search']" style="width: 11px; height: 11px;" />
          + Detalhes
        </button>

      </div>
      <section v-if="!isSimulacaoRoute"
        style="display: flex; justify-content: space-between; margin: 0 .5rem .3rem .5rem">
        <label :for="'comparar-checkbox-' + Plano.calculo.total_iof">
          <input type="checkbox" v-model="Plano.checked" @change="emitCheckboxChange" /> Comparar
        </label>

        <a v-if="!isSimulacaoRoute && isWhatsApp()" class="contatar-button" target="_blank"
          :href="urlWhatsApp()">
          <i class="fab fa-whatsapp"></i> Contatar
        </a>
        <a v-if="!isSimulacaoRoute && !isWhatsApp()" class="contatar-button" target="_blank"
          @click="modalOpen('contato')">
          <i class="fa fa-paper-plane"></i> Enviar
        </a>
      </section>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHospital, faFlask, faSearch } from '@fortawesome/free-solid-svg-icons';

library.add(faHospital, faFlask, faSearch);


export default {
  name: "PlanCard",

  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
    console.log(this.whatsapp)
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },

  data() {
    return {
      isChecked: false,
      showButtons: false,
    };
  },
  computed: {
    normalizedPlanColor() {
      let color = this.plano.operadora.cor;
      if (!color.startsWith("#")) {
        this.planColor = "#" + color;
      }
      this.planColor = color;
    },
    isSimulacaoRoute() {
      return this.$route.path.includes('/simulacao');
    },

    calculoDescricao() {
      let stringComQuebrasDeLinha = this.Plano.calculo.taxa_descricao;
      let stringComQuebrasCorrigidas = stringComQuebrasDeLinha ? stringComQuebrasDeLinha.replace(/<br\s*\/?>/g, '\n') : '';

      return stringComQuebrasCorrigidas
    }

  },
  components: {
  },

  methods: {
    ...mapActions("share", ["updateAux"]),

    extractPrice(value) {
      // Extrai o preço unitário do valor
      const matches = value.match(/R\$\s*([\d.,]+)/);
      if (matches && matches.length > 1) {
        return `R$ ${matches[1]}`;
      }
      return '';
    },
    extractLives(value) {
      // Extrai o número de vidas do valor
      const matches = value.match(/X\s*(\d+)/);
      if (matches && matches.length > 1) {
        return matches[1];
      }
      return '';
    },
    calculateTotal(price, lives) {
      if (price && lives) {
        const priceNumeric = parseFloat(price.replace('R$', '').replace('.', '').replace(',', '.').trim());
        const total = priceNumeric * lives;
        return `R$ ${total.toLocaleString('pt-BR')}`;
      }
      return '';
    },
    emitCheckboxChange() {
      this.$emit("checkbox-change", this.isChecked);
    },

    chamarEditaPlano() {
      this.editaPlano(this.Plano.key_cenario, this.Plano.operadora, this.Plano);
      this.showButtons = false;
    },
    chamarRemovePlano() {
      this.removePlano(this.Plano.key_cenario, this.Plano.operadora, this.Plano);
      this.showButtons = false;
    },
    chamarMaisInformacoes(tab) {
      this.maisInformacoes(this.Plano.key_cenario, this.Plano.operadora, this.Plano, tab)
    },
    isWhatsApp() {
      return this.whatsapp.opcoes.user.telefones.length > 0
        ? this.whatsapp.opcoes.user.telefones.filter(t => t.whatsapp == '1').length > 0
        : false
    },
    urlWhatsApp() {
      let url = '#'
      if (this.isWhatsApp()) {
        let whatsapp = this.whatsapp.opcoes.user.telefones.filter(t => t.whatsapp == '1').shift();
       url = 'https://wa.me/55'
        + whatsapp.ddd
        + whatsapp.fone
        + '?text=' + encodeURIComponent(
          'Olá ' + this.whatsapp?.nome + '!' + ' '
          + 'Gostaria de saber mais informações sobre esta cotação que você me enviou' + ' ' + '[' + '#' + this.whatsapp?.id + ']' + ' ' + 'através do link:' + ' ' +
          this.whatsapp?.url + ' ' + 'Tenho interesse no plano' + ' ' + this.Plano.nome + ' ' + 'no aguardo Obrigado(a)!')
      }
      return url
    },
    modalOpen(modal) {
      if (modal == 'contato') {
        window.document.body.classList.remove('sidebar-open')
        this.$bvModal.show('modal-contato')
      }
    }
  },
  props: {
    Plano: {
      type: Object
    },
    ShowRecomendar: {
      type: Boolean
    },
    Recomendar: {
      type: String
    },
    PlanLogo: {
      type: String,
    },
    PlanName: {
      type: String,
    },
    PlanSubName: {
      type: String,
    },
    PlanInfoName: {
      type: String,
    },
    PlanMode: {
      type: String,
    },
    PlanLodging: {
      type: String,
    },
    PlanCoparticipation: {
      type: String,
    },
    PlanCompulsory: {
      type: String,
    },
    PlanCoverage: {
      type: String,
    },
    PlanRefund: {
      type: Number,
    },
    PlanValue: {
      type: Number,
    },
    TotalIOF: {
      type: Number,
    },
    PlanCalculo: {
      type: Object,
    },
    TotalHospitals: {
      type: Number,
    },
    TotalLaboratories: {
      type: Number,
    },
    CompareFeature: {
      type: Function,
    },
    OpenDetailsModal: {
      type: () => Function
    },
    Titulares: {
      type: Object,
    },
    IsChecked: {
      type: Boolean,
    },
    editaPlano: {
      type: Function
    },
    removePlano: {
      type: Function
    },
    maisInformacoes: {
      type: Function,
    },
    dataToDeleteOrEdit: {
      type: Object
    },
    planColor: {
      type: String,
    },
    modalidade: {
      type: String
    },
    Cenario: {
      type: Object,
    },
    whatsapp: {
      type: Object
    }

  },
};
</script>

<style scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

.card {
  width: 20rem;
  margin: 0 auto;
  box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
  overflow: hidden;

}

.CardHeader {
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding: 1rem 0;
  overflow: hidden;
}

.Recomended {
  width: 10rem;

  background-color: #f3dc836b;
  color: #b5a357cc;
  text-align: center;

  position: absolute;
  right: -2rem;
  top: 2rem;
  transform: rotate(45deg);
}

.Recomended span {
  font-size: 0.8rem;
}

.Recomended:hover .Tooltip {
  display: flex;
}

.Recomended .Tooltip {
  display: none;

  animation: bounce2 3s ease-in-out infinite;
  position: absolute;
  bottom: 9.5rem;

  background-color: #f3de83f1;

  border-radius: 5px;
  opacity: 1;

  z-index: 999999;
}

.Recomended .Tooltip section {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: .5rem;

}

.Recomended .Tooltip section span {
  font-size: 1.1rem;
  white-space: pre-line;
  color: rgb(90, 89, 89);
}

.Recomended .Tooltip section:nth-child(1) {
  font-size: .9rem;
  font-weight: 500;
}

.CardHeader img {
  width: 120px;
  margin: 0 auto;
}

.CardHeader span {
  margin: .5rem 0 -.75rem 0;
  color: #6c757d;
  font-size: 1rem;
}

.TopCardInfo {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  height: 2rem;
}

.PlanName {
  font-size: 17px;
  font-weight: 100;
  color: #007bff;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.PlanSubName {
  font-weight: 300;
  color: #6c757d;
  text-transform: none;
  padding-right: 1.2rem;
}

.PlanSubNameBox {
  color: #000;
  height: 2rem;
  border-radius: 5px;
  display: none;
  position: absolute;
  z-index: 99;
  padding: .2rem;
  background-color: #f3de83f1;
  top: 7rem;
  left: 50%;
  transform: translateX(-50%);


}

.PlanSubName:hover+.PlanSubNameBox {
  display: flex;
}

.Line {
  height: 2px;
  width: 100%;
  margin: -.2rem 0;
}

.Modalidade {
  font-size: 18px;
  font-weight: 200;
}

.Info {
  display: flex;
  flex-direction: column;
  padding: .5rem .2rem;

  color: #708090;
  font-size: 0.9rem;

}

.HeaderInfo {
  display: block;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.HeaderInfo h6 {
  font-weight: 400;
  margin: 0 .2rem;
  color: #343a40;
  font-size: 20px;
  text-transform: none;
  overflow: hidden;
  text-overflow: ellipsis;
}

.HeaderInfo i {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}


.SubInfo {
  margin-top: .4rem;
  font-size: 0.75rem;
}

.SubInfo span:nth-child(2) {
  margin: 0 .5rem;
}

.MiddleInfo {
  font-size: 16px;
  font-weight: 100;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  color: #575c6a;
}

.MiddleInfo b {
  font-size: 16px;
  font-weight: 600;
  color: #575c6a;
}

.PlanValue {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #708090;
  padding: 1rem 0;

  cursor: default;
}

.PlanValue span:nth-child(1) {
  font-size: 0.8rem;
}


.Price:hover .SubTotalBox {
  display: flex;
}

.Price {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 1rem;
  color: #017bff85;

  margin: 0 .3rem;
}

.Price p {
  font-weight: 400;
  color: #007bff;
}

.MoneySign {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.Value {
  font-weight: 600;
  font-size: 1.9rem;
  width: fit-content;
  margin: 0 .3rem;
}

.SubTotalBox {
  display: none;

  animation: bounce2 3s ease-in-out infinite;
  position: absolute;
  bottom: 9.5rem;

  background-color: #f3de83f1;

  border-radius: 5px;
  opacity: 1;

  z-index: 999999;
}

.SubTotalBox section {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: .5rem;

}

.SubTotalBox section span {
  font-size: 1.1rem;
  white-space: pre-line;
  color: rgb(90, 89, 89);
}

.SubTotalBox section:nth-child(1) {
  font-size: .9rem;
  font-weight: 500;
}

.SubTotlBox section b {
  font-weight: 300;
  font-size: 1rem
}

.IOFContainer {
  display: none;
  justify-content: center;
  animation: bounce2 3s ease-in-out infinite;
  position: absolute;
  background-color: #f3de83f1;
  border-radius: 5px;
  width: 9rem;
  right: 1rem;
  bottom: .3rem;
  z-index: 3;
}

.IOFContainer section {
  padding: .2rem;
}

.IOFContainer header {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: .3rem;
}

.IOFContainer header b,
small {
  color: rgb(90, 89, 89);
  font-weight: 600;
}

.IOFContainer span {
  font-size: .9rem;
}

.IOFContainer main {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.TotalIOF:hover .IOFContainer {
  display: block;
}

@keyframes bounce2 {

  0%,
  1%,
  5% {
    transform: translateY(0);
  }

  10% {
    transform: translateY(-5px);
  }

  15% {
    transform: translateY(-10px);
  }
}

.BottomButtons {
  padding: .5rem .5rem;
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;

}

.BottomButtons button {
  cursor: pointer;

  border-radius: 5px;
  border: solid 1px #83838320;

  width: 5.5rem;
  height: 2.188rem;
  margin: 0.7rem 0;

  background-color: #fff;

  color: #838383;
  font-size: .813rem;

  transition: ease-in-out 0.2s;
}


.BottomButtons button:hover {
  background-color: #838383;
  color: white;
}

.BottomButtons div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #fff;
  border-radius: 50%;
  border: solid 1px #83838320;
  position: absolute;
  padding: 0.5rem;
  color: #838383;
  transition: ease-in-out 0.2s;


  font-size: 12px;
}

.Hospitals {
  left: 13%;
  bottom: 4.6rem;
  width: 1.5rem;
  height: 1.5rem;
  z-index: 2;
}

.Laboratories {
  left: 46%;
  bottom: 1.6rem;
  width: 1.5rem;
  height: 1.5rem;
  z-index: 2;
}

@media screen and (max-width: 850px) {
  .BottomButtons button {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: .5rem;
    height: 2.5rem;
  }

  .BottomButtons div {
    bottom: 55px;
  }

  .Hospitals {
    left: 12.5%;
  }
}

.BottomMenu {
  background-color: rgba(0, 0, 0, .03);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.5rem;
  padding: 1rem;
  margin: .3rem;
}

.InputContainer {
  display: flex;
  align-items: center;
  text-align: center;
}

.InputContainer input {
  border-radius: 20px;
}

.InputContainer p {
  margin: 0;
  padding-left: 0.4rem;
  color: #017bff85;
}

.Zapzap {
  cursor: pointer;

  display: flex;
  align-items: center;
  padding-left: 0.2rem;

  background-color: #fff;
  width: 4.8rem;
  height: 1.5rem;

  transition: ease-in 0.2s;
}

.Zapzap :hover {
  background-color: green;
  color: #fff;

}

.Zapzap p {
  font-size: .9rem;

  border-radius: .15rem;
  color: green;
  margin: 0;
}

.ButtonsContainer {
  position: relative;
}

.ButtonsBox {
  cursor: pointer;
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  border: 1px solid #cccccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1;
  padding: 5px 15px;
  margin: 5px 0;
  border-radius: 5px;
  transition: 0.3s;
}

.ButtonsBox :hover {
  border-radius: 5px;
  background-color: #e2e1e127;
}

.contatar-button {
  background-color: transparent;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  color: #28a745;
}

.contatar-button i {
  font-size: 20px;
  margin-right: 5px;
}

.contatar-button:hover {
  background-color: #28a745;
  color: #fff;
}

.contatar-button a {
  color: #25d366;
}

.contatar-button a:hover {
  background-color: #25d366;
  color: #fff;
}

label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

input[type="checkbox"] {
  margin-right: 5px;
}

.table-container {
  margin: 0 auto;
  max-width: 800px;
}

.column-margin {
  margin: 0 0.5rem;
  font-weight: 300;
  text-align: center;
  color: gray;
}
</style>
